"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var React = _interopRequireWildcard(require("react"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function SvgComponent(props, svgRef) {
  return (0, _jsxRuntime.jsx)("svg", _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), {}, {
    children: (0, _jsxRuntime.jsx)("path", {
      fill: "currentColor",
      d: "M19.343 13.281a.887.887 0 00-1.109.577 6.333 6.333 0 01-6.093 4.366 6.298 6.298 0 01-6.367-6.212A6.297 6.297 0 0112.14 5.8a6.429 6.429 0 014.124 1.482l-1.924-.32a.889.889 0 00-.864 1.4c.138.192.347.32.58.357l3.76.622h.151a.867.867 0 00.302-.054.283.283 0 00.088-.053.699.699 0 00.178-.097l.08-.098c0-.044.08-.08.115-.133.035-.053 0-.089.044-.124.025-.052.045-.106.062-.16l.665-3.55a.905.905 0 00-1.184-1.022.905.905 0 00-.59.685l-.239 1.287a8.159 8.159 0 00-5.348-1.997C7.691 3.985 4.05 7.559 4 12.012c.049 4.453 3.691 8.026 8.141 7.987a8.088 8.088 0 007.822-5.609.89.89 0 00-.62-1.109z"
    })
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgComponent);
var _default = ForwardRef;
exports["default"] = _default;
//# sourceMappingURL=Reset.js.map